import React from "react";
import { Link as RouterLink } from "react-router-dom";

/* other */
import history from "./history";
import routes from "./routes";
import { RouteError } from "./errors";

let to = {};
routes.forEach(route => to[route.name] = () => history.push(route.path));

export const navigate = {
    to,
    back: () => history.goBack(),
};

export function Link({ to, className, children, ...rest }) {
    let route = routes.find(route => route.name === to);
    
    if (!route) {
        throw new RouteError(`Unknown route "${to}".`);
    }

    return <RouterLink to={route.path} className={className} {...rest}>{children}</RouterLink>;
}
